export default __webpack_public_path__ + "static/stickermule-bed49b2be0c3576841ff903e4ed273c9.svg";